import { createSlice } from "@reduxjs/toolkit";
import { NODE_TYPES } from "common/constants/enums";

const initialState: any = {
  json: {
    nodes: [],
    edges: [],
    viewport: {
      x: 540.0259415913994,
      y: 294.4550148930189,
      zoom: 0.5,
    },
  },
  nodeToEdit: null,
  nodeToAdd: null,
  sectionSummeryGroupId: null,
};

export const nodesSlice = createSlice({
  name: "nodes",
  initialState,
  reducers: {
    setNodeToEdit: (state, { payload }) => {
      state.nodeToEdit = payload;
    },
    setNodeToAdd: (state, { payload }) => {
      state.nodeToAdd = payload;
    },
    setNodes: (state, { payload }) => {
      state.json.nodes = payload;
    },
    setJson: (state, { payload }) => {
      state.json = payload;
    },
    addNode: (state, { payload }) => {
      state.json.nodes.push(payload);
    },
    deleteNode: (state, { payload }) => {
      function filterNodes(data: any): any {
        const ids = new Set(data.map((item: any) => item.id));
        const result = data.filter(
          (item: any) => item.data?.nodeType === NODE_TYPES.section || ids.has(item.parentNode)
        );
        return result.length === data.length ? result : filterNodes(result); // Recursively filter until stable
      }
      state.json.nodes = filterNodes(state.json.nodes.filter((n: any) => n.id !== payload));
    },
    updateNode: (state, { payload: { id, newNodeData } }) => {
      const index = state.json.nodes.findIndex((node: any) => node.id === id);
      if (index !== -1) state.json.nodes[index] = { ...state.json.nodes[index], ...newNodeData };
    },
    setSectionSummeryGroupId: (state, { payload }) => {
      state.sectionSummeryGroupId = payload;
    },
  },
});

export const {
  setNodes,
  deleteNode,
  addNode,
  updateNode,
  setNodeToEdit,
  setNodeToAdd,
  setJson,
  setSectionSummeryGroupId,
} = nodesSlice.actions;
export default nodesSlice.reducer;
